/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { v4 as uuidv4 } from "uuid";
import config from "../config/kanbanList.config.json";

export interface IKanbaListMethods extends IPluginMethodMap {
  getKanbanList(args: any): any;
  getKanbanProps(args: any): any;
  updateKanbanList(args: any): any;
}

export class KanbanListService implements IAgentPlugin {
  readonly methods: IKanbaListMethods;
  private list: any[] = config.kanbanList;
  constructor() {
    this.methods = {
      getKanbanList: this.getList.bind(this),
      getKanbanProps: this.getProps.bind(this),
      updateKanbanList: this.updateList.bind(this),
    };
    this.list[0].id = uuidv4();
  }

  getProps(args: any) {
    console.log("1->", this.list);
    return {
      ...(config || {}),
      kanbanList: this.list,
    };
  }

  updateList(args: any) {
    console.log(args);
    if (args) {
      console.log(args);
      this.list = [...args];
    }
  }

  getList(args: any) {
    return {
      kanbanList: this.list,
    };
  }
}
